module.exports = __webpack_public_path__ + "static/media/zoomDisplayIconDarkBlue.372cfc56.svg";